(function() { window.GUID_1a38d2a7_6c44_4c2d_9239_911c06101908 = { getGuid: function() { return "1a38d2a7-6c44-4c2d-9239-911c06101908"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        function ShowUserValidatorPopup(currentForm, callback) {
            var me = this;
            var popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'UserValidatorPopup',
                Url: CSParameters.BaseUrl + 'Account/ShowUserValidator/',
                Async: false,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (result) {
                currentForm.append('<input type="hidden" value="' + result.token + '" name="UserValidatorToken" />');
                callback();
            };
        }
        Controls.ShowUserValidatorPopup = ShowUserValidatorPopup;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=UserValidator.js.map
